/** Clase para los detalles de la tarifa */
export default class PricingRate {
  /** (String): Forma de pago. Ejemplo: "Mensual". */
  billingCycle!: string

  /** (String): Precio en euros. Ejemplo: "40,04". */
  price!: string
  totalPrice!: string

  constructor(data: any) {
    this.billingCycle = data.billingCycle
    this.price = data.price
    this.totalPrice = data.totalPrice
  }
}
